<template>
<v-card
    :class="{'max_width': !fluid}"
    style="margin: auto; margin-bottom: 15px;"
    v-if="payment != null && payment.state == 'open'"
>
    <v-card-title>
    <v-icon
        style="margin-right: 10px"
    >
        mdi-map-marker
    </v-icon>
        {{title}}
    </v-card-title>

    <v-card-text>
        <v-row
            v-if="show_same_as_shipping"
        >
            <v-col>
                <v-checkbox
                    v-model="same_as_shipping"
                    label="My billing address is the same as my shipping address"
                    v-on:change="onInput"
                />
            </v-col>
        </v-row>
        
        <v-row 
            v-if="show_fields"
            dense
        >
            <v-col>
                <rc-base-input
                    type="text"
                    label="Address Line 1"
                    v-model="address_line1"
                    autocomplete="address-line1"
                    required
                    @input="onInput"
                >
                    <v-btn
                        slot="append-outer"
                        v-if="show_line_2 == false"
                        aria-label="Show address line 2"
                        title="Show address line 2"
                        icon
                        small
                        @click="show_line_2 = true"
                    >
                        <v-icon>mdi-plus-circle</v-icon>
                    </v-btn>
                </rc-base-input>
            </v-col>
        </v-row>

        <v-row 
            v-if="show_line_2 && show_fields"
            dense
        >
            <v-col>
                <rc-base-input
                    type="text"
                    label="Address Line 2"
                    v-model="address_line2"
                    autocomplete="address-line2"
                    @input="onInput"
                >
                    <v-btn
                        slot="append-outer"
                        v-if="show_line_3 == false"
                        aria-label="Show address line 3"
                        title="Show address line 3"
                        icon
                        small
                        @click="show_line_3 = true"
                    >
                        <v-icon>mdi-plus-circle</v-icon>
                    </v-btn>
                </rc-base-input>
            </v-col>
        </v-row>

        <v-row 
            v-if="show_line_3 && show_fields"
            dense
        >
            <v-col>
                <rc-base-input
                    type="text"
                    label="Address Line 3"
                    v-model="address_line3"
                    outlined
                    dense
                    autocomplete="address-line3"
                    @input="onInput"
                />
            </v-col>
        </v-row>

        <v-row 
            v-if="show_fields"
            dense
        >
            <v-col cols="12" sm="6">
                <rc-base-input
                    type="text"
                    label="City"
                    v-model="city"
                    autocomplete="off"
                    required
                    @input="onInput"
                />
            </v-col>

            <v-col cols="12" sm="3">
                <rc-base-input
                    type="text"
                    label="State / Province"
                    v-model="state"
                    autocomplete="off"
                    required
                    @input="onInput"
                />
            </v-col>

            <v-col cols="12" sm="3">
                <rc-base-input
                    type="text"
                    mode="numeric"
                    label="Zip / Postal Code"
                    v-model="postal_code"
                    autocomplete="postal-code"
                    required
                    @input="onInput"
                />
            </v-col>
        </v-row>

        <v-row>
        <v-col>
            <v-btn
            style="width: 100%;"
            color="#5D647C"
            dark
            v-on:click="onContinue"
            v-if="active"
            >
            {{action_text}}
            </v-btn>
        </v-col>
        </v-row>

    </v-card-text>

</v-card>
</template>

<script>
import RcBaseInput from '@/components/shared/inputs/rc-base-input.vue';

export default {
    components: {
        RcBaseInput
    },

    props: {

        payment: {
            type: Object,
            default: function() { return null; }
        },

        shipping: {
            type: Boolean,
            default: function() { return false; }
        },

        active: {
            type: Boolean,
            default: function() { return false; }
        },

        action_text: {
            type: String,
            default: function() { return 'Continue'; }
        },

        allow_same_as_shipping: {
            type: Boolean,
            default: function() { return true; }
        },

        fluid: {
            type: Boolean,
            default: function() { return false; }
        },
    },

    created () {
        this.$event_bus.$on('payment-fill-sample', this.onFillSample);
    },

    beforeDestroy () {
        this.$event_bus.$off('payment-fill-sample',this.onFillSample);
    },

    data() {
        return {
            address_line1: null,
            address_line2: null,
            address_line3: null,
            city: null,
            state: null,
            postal_code: null,
            country: 'US',
            show_line_2: false,
            show_line_3: false,
            same_as_shipping: true,
        }
    },

    methods: {

        nullToBlank(value)
        {
            if ( value == null ) return '';
            return value.trim();
        },

        blankToNull(value)
        {
            if ( value == null ) return value;
            if ( value.trim().legth == 0 ) return null;
            return value.trim();
        },

        onlyDigits(value)
        {
            value = this.nullToBlank(value);
            return value.replace(/\D/g, "");
        },

        createAddress()
        {
            if ( this.show_same_as_shipping && !this.shipping && this.same_as_shipping ) return { 'same_as_shipping' : true };

            let address_line1 = this.nullToBlank(this.address_line1);
            if ( address_line1.length == 0 ) return { 'error' : 'You must specify a '+this.short_desc+' street address' };

            let address_line2 = this.blankToNull(this.address_line2);
            let address_line3 = this.blankToNull(this.address_line3);

            let city = this.nullToBlank(this.city);
            if ( city.length == 0 ) return { 'error' : 'You must specify a '+this.short_desc+' city' };

            let state = this.nullToBlank(this.state);
            if ( state.length < 2 ) return { 'error' : 'You must specify a '+this.short_desc+' state' };

            let postal_code = this.nullToBlank(this.postal_code);
            if ( postal_code.length < 5 ) return { 'error' : 'You must specify a '+this.short_desc+' zip / postal code' };

            return {
                'address_line1' : address_line1,
                'address_line2' : address_line2,
                'address_line3' : address_line3,
                'city' : city,
                'state' : state,
                'postal_code' : postal_code,
                'country' : this.country,
            };
        },

        onFillSample()
        {
            this.address_line1 = '123 Main St';
            this.address_line2 = null;
            this.address_line3 = null;
            this.city = 'Anytowne';
            this.state = 'AZ';
            this.postal_code = '86001';
            this.country = 'US';
            this.show_line_2 = false;
            this.show_line_3 = false;
            this.$emit('input', this.createAddress());  
        },

        onInput()
        {
            this.$emit('input', this.createAddress());  
        },

        onContinue()
        {
            let address = this.createAddress();

            if ( address.error != null )
            {
                this.$rc.snackbar(address.error,3500);
                return;
            }

            this.$emit('continue',address);
        },

        validate()
        {
            // Called by other controls to validate that this field is "good to go"

            let address = this.createAddress();
            if ( address.error != null )
                return address.error;

            return null;
        },
    },

    computed: {
        title() {
            if ( this.shipping ) return 'Shipping Address';
            return 'Billing Address';
        },

        short_desc() {
            if ( this.shipping ) return 'shipping';
            return 'billing';
        },

        show_fields() {
            if ( !this.show_same_as_shipping ) return true;
            if ( !this.shipping && this.same_as_shipping ) return false;

            return true;
        },

        show_same_as_shipping() {
            if ( this.shipping == true ) return false;
            if ( this.allow_same_as_shipping == false ) return false;
            return true;
        }
    },
}
</script>

<style lang="scss" scoped>
.max_width
{
    width: 550px;
}
</style>